import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { get, post } from "../../api";
import Button from "../../components/Button";
import Frame from "../../components/Frame";
import FrameHeader from "../../components/FrameHeader";
import moment from "moment";
import InputRow from "../../components/InputRow";
import CheckboxWithLabel from "../../components/CheckboxWithLabel";
import LoadingFrame from "../../components/LoadingFrame";
import Modal from "../../components/Modal";
import Space from "../../components/Space";
import styles from "./CustomerSubscriptionDetail.module.scss";
import { useConfirm } from "material-ui-confirm";
import queryString from "query-string";
import Icon from "../../components/Icon";
import DataValue from "../../components/DataValue";
import StatusIndicator from "../../components/StatusIndicator";
import FrameFooter from "../../components/FrameFooter";
import PaymentProfile from "../../components/PaymentProfile/PaymentProfile";
import { useMediaQuery } from "react-responsive";
import Select from "../../components/Select";
import Label from "../../components/Label";
import { AuthContext } from "../../contexts/Auth";
import SalesRepresentativeBanner from "../../components/SalesRepresentativeBanner/SalesRepresentativeBanner";
import getStatus from "../../helpers/statuses";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
export default function CustomerSubscriptionDetail({
  match: { params },
  location: { search },
}) {
  const { state: currentUser } = useContext(AuthContext);
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
  const [loading, setLoading] = useState(true);
  const queryParams = queryString.parse(search);
  const [customer, setCustomer] = useState(null);
  const [subcriptionSummary, setSubcriptionSummary] = useState([]);
  const [originalsubcriptionSummary, setOriginalSubcriptionSummary] = useState(
    []
  );
  const [selectedDevicesToAssign, setSelectedDevicesToAssign] = useState([]);
  const [assigning, setAssigning] = useState(false);
  const [manageSubscription, setManageSubscription] = useState(false);
  const [devicesLoading, setDevicesLoading] = useState(false);
  const [noLicense, setNoLicense] = useState([]);
  const [assigningLoading, setAssigningLoading] = useState(false);
  const [expiredLicense, setExpiredLicense] = useState([]);
  const [autoRenew, setAutoRenew] = useState(true);
  const [error, setError] = useState(null);
  const [cart, setCart] = useState([]);
  const [disabledAutomatic, setDisabledAutomatic] = useState(false);
  const [loadingLicenseId, setLoadingLicenseId] = useState(0);
  const [editingSub, setEditingSub] = useState(null);
  const [tempQuantity, setTempQuantity] = useState(0);
  const [paymentInProgress, setPaymentInProgress] = useState(false);
  const [customerPaymentProfile, setCustomerPaymentProfile] = useState(null);
  const [openAddCCModal, setOpenAddCCModal] = useState(false);
  const confirm = useConfirm();
  var selectedDevices = [];
  const [enableSelectionMode, setEnableSelectionMode] = useState(false);
  const [selectingAll, setSelectingAll] = useState(false);
  const [licencesSelectedForRenewal, setLicencesSelectedForRenewal] = useState(
    []
  );

  const [openCheckoutModal, setOpenCheckoutModal] = useState(false);
  const handleRemoveFromCart = (index) => {
    confirm({
      description:
        "Are you sure you want to remove this item from the shopping cart?",
      title: null,
      dialogProps: { fullScreen: false },
      cancellationButtonProps: { color: "error", disableRipple: true },
      confirmationButtonProps: { color: "primary", disableRipple: true },
    })
      .then(() => {
        setCart((currentCart) => currentCart.filter((_, i) => i !== index));
      })
      .catch(() => { });
  };
  const getCustomerProfile = async () => {
    const customerProfile = await Promise.all([
      get(`/customers/${currentUser.user.customer_id}`),
    ]);
    customerProfile && setCustomer(customerProfile?.[0]);
  };
  const handleAddToCart = (option, serial_number, quantity = 1) => {
    let price = 240;
    switch (option) {
      case "oneYear":
        break;
      case "threeYear":
        price = 648;
        break;
      case "fiveYear":
        price = 900;
        break;
    }
    setCart((currentCart) => {
      const existingItemIndex = currentCart.findIndex(
        (item) => item.option === option
      );

      if (existingItemIndex >= 0) {
        const updatedCart = [...currentCart];
        const serial_numbers = updatedCart[existingItemIndex].serial_number;
        if (!serial_numbers.includes(serial_number)) {
          serial_numbers.push(serial_number);
        }
        const quantity_modified =
          updatedCart[existingItemIndex].quantity + quantity;
        updatedCart[existingItemIndex] = {
          ...updatedCart[existingItemIndex],
          quantity: quantity_modified,
          serial_number: serial_numbers,
        };

        return updatedCart;
      } else {
        const newItem = {
          option: option,
          quantity: quantity,
          price: price,
          serial_number: [serial_number],
        };

        return [...currentCart, newItem];
      }
    });
  };

  useEffect(() => {
    getCustomerProfile();
    fetchCustomerSubscriptons();
  }, []);

  function updateSubscriptionSummary(subcriptionSummary) {
    if (subcriptionSummary) {
      const allOptions = [365, 365 * 3, 365 * 5]; // all possible options

      const updatedSubscriptions = allOptions.map((option) => {
        const subscription = subcriptionSummary?.subscriptions?.find(
          (sub) => sub.duration === option
        );
        if (subscription) {
          return subscription;
        }
        return {
          license_count: 0,
          used: 0,
          duration: option,
          id: Math.floor(Math.random() * 100000),
        };
      });

      subcriptionSummary = {
        ...subcriptionSummary,
        subscriptions: updatedSubscriptions,
      };

      setSubcriptionSummary(subcriptionSummary);
      setOriginalSubcriptionSummary(subcriptionSummary);
    }
  }

  async function placeOrder() {
    try {
      setPaymentInProgress(true);
      const res = await post("/checkout/placeorder", {
        customer_id: customer.id,
        cart,
      });
      if (res) {
        if (res?.success) {
          await fetchCustomerSubscriptons();
          setPaymentInProgress(false);
          setManageSubscription(false);

          setPaymentInProgress(false);
          setEnableSelectionMode(false);
          setCart([]);
          setSelectedDevicesToAssign([]);
          setOpenCheckoutModal(false);
        } else {
          setError(res.content);
          confirm({
            description:
              res.content ||
              "Looks like something went wrong with the payment process. Contact the Sentinel support team to troubleshoot this issue. Call 949-361-5663 or e-mail sentinelsupport@traffixdevices.com.",
            title: "Unable to place order",
            dialogProps: { fullScreen: false },
            cancellationButtonProps: { style: { display: "none" } },
            confirmationButtonProps: { color: "primary", disableRipple: true },
          })
            .then(() => {
              setPaymentInProgress(false);
              setEnableSelectionMode(false);
              setCart([]);
              setSelectedDevicesToAssign([]);
              setOpenCheckoutModal(false);
            })
            .catch(() => {
              /* ... */
            });
        }
        setPaymentInProgress(false);
      }
    } catch (e) {
      console.log(e);
      setError(e?.message || "An error occurred");
      setPaymentInProgress(false);
    }
  }

  async function fetchCustomerSubscriptons() {
    setLoading(true);
    setDisabledAutomatic(false);
    setAutoRenew(true);
    setCustomerPaymentProfile(null);

    const subcriptionSummary = await Promise.all([
      get(`/customers/subscriptions`),
    ]);
    const customerPaymentProfile = await Promise.all([
      get(`/customers/paymentprofile`),
    ]);
    customerPaymentProfile &&
      customerPaymentProfile[0] &&
      customerPaymentProfile[0]?.length > 0 &&
      setCustomerPaymentProfile(customerPaymentProfile[0]);

    subcriptionSummary &&
      subcriptionSummary[0] &&
      updateSubscriptionSummary(subcriptionSummary[0]);

    subcriptionSummary &&
      subcriptionSummary[0] &&
      subcriptionSummary &&
      subcriptionSummary[0] &&
      subcriptionSummary[0].devices_with_expired_license &&
      setExpiredLicense(subcriptionSummary[0].devices_with_expired_license);

    subcriptionSummary &&
      subcriptionSummary[0] &&
      subcriptionSummary[0].devices_no_license &&
      setNoLicense(subcriptionSummary[0].devices_no_license);

    subcriptionSummary &&
      subcriptionSummary[0] &&
      subcriptionSummary[0].devices_with_expired_license.length > 0 &&
      subcriptionSummary[0].devices_with_expired_license.map((type) => {
        var id = type.id;
        selectedDevices.push(id);
      });

    setSelectedDevicesToAssign(selectedDevices);

    if (
      subcriptionSummary[0]?.subscriptions_active -
      subcriptionSummary[0]?.subscriptions_in_use -
      subcriptionSummary[0]?.devices_with_active_license.length <
      subcriptionSummary[0]?.devices_with_expired_license.length
    ) {
      if (
        subcriptionSummary[0].devices_with_expired_license.length >
        subcriptionSummary[0].licenses_active_no_device.length
      ) {
        setDisabledAutomatic(true);
        setAutoRenew(false);
        setSelectedDevicesToAssign([]);
      }
    }

    if (queryParams.assign) {
      setAssigning(true);
    }
    setLoading(false);
  }

  async function assignDevices() {
    setAssigningLoading(true);
    const res = await post(`/customer/subscriptions/auto/assign`, {
      auto_assign: autoRenew,
      devices: selectedDevicesToAssign,
    });

    if (res) {
      window.location.replace("/subscription");
    } else {
      alert("Sorry, we encountered an error.");
    }
    setAssigningLoading(false);
  }

  async function changeStateForLicenseId(subId, licenseId, state) {
    setLoadingLicenseId(licenseId);
    const res = await post(`/subscriptions/licenses/${licenseId}`, {
      state: state,
    });

    if (!res) {
      alert("Sorry, we encountered an error.");
      return;
    }

    var tempSummary = subcriptionSummary.subscriptions;
    tempSummary.map((sub) => {
      if (sub.id == subId) {
        sub.licenses.map((lic) => {
          if (lic.id == licenseId) {
            lic.auto_renew = state;
          }
        });
      }
      if (subcriptionSummary.licenses?.length > 0) {
        subcriptionSummary.licenses?.map((lic) => {
          if (lic.id == licenseId) {
            lic.auto_renew = state;
          }
        });
      }
    });

    subcriptionSummary.subscriptions = tempSummary;
    setSubcriptionSummary(subcriptionSummary);

    setLoadingLicenseId(0);
  }

  async function refresh() {
    setLoading(true);

    await fetchCustomerSubscriptons();
    setLoading(false);
  }

  function _renderModelFooter() {
    return (
      <>
        <Button onClick={() => setAssigning(false)}>Cancel</Button>
        <Button
          disabled={selectedDevicesToAssign.length === 0 || assigningLoading}
          theme="primary"
          isLoading={assigningLoading}
          onClick={() => assignDevices()}
        >
          Assign
        </Button>
      </>
    );
  }

  function _renderSubscriptionManageModelFooter() {
    return (
      <>
        <Button
          disabled={paymentInProgress}
          onClick={() => {
            setOpenCheckoutModal(false);
          }}
        >
          Cancel
        </Button>
        <Space>&nbsp;</Space>
        <Button
          disabled={
            !customerPaymentProfile ||
            paymentInProgress ||
            !cart.some((item) => item.quantity > 0)
          }
          theme="primary"
          isLoading={paymentInProgress}
          onClick={() => {
            const cartString = cart
              .map(
                (item) =>
                  `${decodeOptionShortCart(item.option)} x ${item.quantity}`
              )
              .join(", ");

            confirm({
              description: "Are you sure you want to place the order?",
              title: "",
              dialogProps: { fullScreen: false },
              cancellationButtonProps: { color: "error", disableRipple: true },
              confirmationButtonProps: {
                color: "primary",
                disableRipple: true,
              },
            })
              .then(() => {
                placeOrder();
              })
              .catch(() => {
                // The user cancelled the confirmation dialog.
              });
          }}
        >
          Place order
        </Button>
      </>
    );
  }

  function _checkoutButtonsForOpeningModal() {
    return (
      <>
        <Button
          disabled={paymentInProgress}
          onClick={() => {
            setCart([]);
            setSubcriptionSummary(originalsubcriptionSummary);
            setManageSubscription(false);
            setSelectedDevicesToAssign([]);
            setEnableSelectionMode(false);
          }}
        >
          Cancel
        </Button>
        <Space>&nbsp;</Space>
        <Button
          disabled={
            !customerPaymentProfile ||
            paymentInProgress ||
            !cart.some((item) => item.quantity > 0)
          }
          theme="primary"
          isLoading={paymentInProgress}
          onClick={() => {
            setOpenCheckoutModal(true);
          }}
        >
          Checkout
        </Button>
      </>
    );
  }

  async function modifyTypes(device_id, checked) {
    setDevicesLoading(true);

    if (checked == true) {
      var array = selectedDevicesToAssign;
      var index = array.indexOf(device_id);
      if (index < 0) {
        array.push(device_id);

        var tempArray = [];
        array.map((item) => {
          if (item != null) {
            tempArray.push(item);
          }
        });
        setSelectedDevicesToAssign(tempArray);
      }
    } else {
      var array = selectedDevicesToAssign;
      var index = array.indexOf(device_id);
      delete array[index];
      var tempArray = [];
      array.map((item) => {
        if (item != null) {
          tempArray.push(item);
        }
      });
      setSelectedDevicesToAssign(tempArray);
    }
    setDevicesLoading(false);
  }

  async function selectAll() {
    setDevicesLoading(true);
    var tempDev = [];
    expiredLicense.map((type) => {
      var id = type.id;
      tempDev.push(id);
    });
    setSelectedDevicesToAssign(tempDev);
    setDevicesLoading(false);
  }

  function selectAutomatic(value) {
    if (value === true) {
      selectAll();
    }
    setAutoRenew(value);
  }

  function stepOption(label, explanation, value) {
    const active = autoRenew === value;
    const classes = [styles.label, active && styles.labelActive].join(" ");

    return (
      <label className={classes}>
        <div className={styles.img}>
          <div className={styles[value]}>
            <Icon name={value === true ? "auto_mode" : "list"} size={56} />
          </div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.flexRow}>
            <div className={styles.text}>{active ? <b>{label}</b> : label}</div>
          </div>
          <div className={styles.flexRow}>
            <div className={styles.sub_text}>
              <p>{explanation}</p>
            </div>
          </div>
        </div>
        <input
          type="radio"
          name="damage"
          value={value}
          disaled={disabledAutomatic}
          onChange={(e) => selectAutomatic(value)}
          checked={active}
          disabled={disabledAutomatic}
        />
      </label>
    );
  }

  function displayDevicesVsSubscriptionCounter() {
    var devicesWithNoLicense =
      subcriptionSummary.devices_with_expired_license.length;
    var available =
      subcriptionSummary.subscriptions_active -
      subcriptionSummary.subscriptions_in_use +
      subcriptionSummary.licenses_active_no_device.length;
    if (devicesWithNoLicense > available) {
      return (
        <Space size="s">
          <p className={styles.red}>
            {devicesWithNoLicense > available === 1
              ? "There is " +
              devicesWithNoLicense +
              " device with expired subscription."
              : "There are " +
              devicesWithNoLicense +
              " devices with expired subscriptions."}
          </p>
        </Space>
      );
    }
  }

  function shouldBeDisabled(dev_id) {
    return selectedDevicesToAssign.indexOf(dev_id) > -1 ? false : true;
  }

  function displayCartItems(enableDelete = true) {
    if (cart?.length > 0) {
      const sortedCart = [...cart].sort((a, b) => {
        const order = ["oneYear", "threeYear", "fiveYear"];
        return order.indexOf(a.option) - order.indexOf(b.option);
      });
      const totalCost = sortedCart.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
      return (
        <>
          <div className={styles.containerOverlay}>
            <div className={styles.header}>Order summary</div>
            <div className={styles.bottomsticky}>
              <div className={styles.cartFrame}>
                {sortedCart.map((item, index) =>
                  isMobile ? (
                    <div key={index} className={styles.quantitycontrolMobile}>
                      <div className={styles.minwidth}>
                        {decodeOptionShort(item.option)}
                      </div>
                      <div className={styles.totalcart}>
                        <div className={styles.quantitycontrol}>
                          <span className={styles.span}>
                            <p> {item.quantity}</p>
                          </span>
                        </div>
                      </div>
                      {enableDelete && (
                        <Button
                          size="s"
                          icon="delete_forever"
                          theme="danger"
                          onClick={() => handleRemoveFromCart(index)}
                        />
                      )}
                    </div>
                  ) : (
                    <div key={index} className={styles.cartItem}>
                      {decodeOptionShort(item.option)}
                      <div className={styles.totalcart}>
                        <div className={styles.quantitycontrol}>
                          <span className={styles.span_small}>
                            <p>Qty: {item.quantity}</p>
                          </span>
                        </div>
                      </div>
                      <span className={styles.span_price}>
                        <b> ${item.price * item.quantity}.00</b>
                      </span>

                      {enableDelete && (
                        <Button
                          size="s"
                          icon="delete_forever"
                          theme="danger"
                          onClick={() => handleRemoveFromCart(index)}
                        />
                      )}
                    </div>
                  )
                )}
              </div>
              <div className={styles.priceRight}>
                <span className={styles.span_price}>
                  Total: <b> ${totalCost}.00</b>
                </span>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return "Cart empty";
    }
  }

  const displayCheckoutModal = () => {
    const hasMissedCommunication = cart.some((item) =>
      item.serial_number.some((sn) => {
        const licForSn = subcriptionSummary?.licenses?.find(
          (lic) => lic.device?.serial_number === sn
        );
        return licForSn?.device?.status === "COMMUNICATION_ERROR";
      })
    );

    const hasNoAsset = cart.some((item) =>
      item.serial_number.some((sn) => {
        const licForSn = subcriptionSummary?.licenses?.find(
          (lic) => lic.device?.serial_number === sn
        );
        return !licForSn?.asset_link;
      })
    );

    return (
      <Modal footer={_renderSubscriptionManageModelFooter()}>
        <PaymentProfile editEnabled={false} />
        <Space size="xs" />
        {cart.length > 0 && (
          <>
            <FrameHeader title="Device" />
            <Frame>
              {hasMissedCommunication && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffeeba",
                    borderRadius: "4px",
                    color: "#856404",
                    marginBottom: "16px",
                    fontSize: "14px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Icon name="info" size={20} color="#856404" />
                    <span style={{ marginLeft: "8px", lineHeight: "1.2" }}>
                      You are renewing licenses for one or more devices that
                      currently are in a missed communication status.
                    </span>
                  </div>
                </div>
              )}
              {hasNoAsset && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#e2e3e5",
                    border: "1px solid #d6d8db",
                    borderRadius: "4px",
                    color: "#383d41",
                    marginBottom: "16px",
                    fontSize: "14px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Icon name="info" size={20} color="#383d41" />
                    <span style={{ marginLeft: "8px", lineHeight: "1.2" }}>
                      One or more devices are not associated with an asset and
                      are not actively being monitored.
                    </span>
                  </div>
                </div>
              )}

              <div style={{ marginTop: "10px" }}>
                <div className={[styles.row, styles.rowHeader].join(" ")}>
                  <div className={styles.rowItem}>
                    <b>Serial number</b>
                  </div>
                  <div className={styles.rowItem}>
                    <b>Device status</b>
                  </div>
                  <div className={styles.rowItem}>
                    <b>Duration selected</b>
                  </div>
                </div>
                {cart.map((item) =>
                  item.serial_number.map((sn) => {
                    const licForSn = subcriptionSummary?.licenses?.find(
                      (lic) => lic.device?.serial_number === sn
                    );
                    const statusForSn = licForSn?.device?.status;
                    return (
                      <div className={styles.twoRows} key={sn}>
                        <div className={styles.row}>
                          <div className={styles.rowItem}>{sn}</div>
                          <div className={styles.rowItem}>
                            <div
                              style={{
                                height: "10px",
                                width: "10px",
                                borderRadius: "50%",
                                backgroundColor: !licForSn?.asset_link
                                  ? "#777777"
                                  : getStatus(statusForSn)?.colors?.[0] || "#777777",
                                marginRight: "8px",
                                flexShrink: 0,
                              }}
                            />
                            {!licForSn?.asset_link
                              ? "No asset"
                              : getStatus(statusForSn)?.name || "Unknown"}
                          </div>
                          <div className={styles.rowItem}>
                            {decodeOptionShortCart(item.option)}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </Frame>
            <Space size="xs" />
          </>
        )}

        {displayCartItems(false)}
      </Modal>
    );
  };
  const returnIconWrapper = (color, text) => {
    return (
      <div className={styles.flexContainer}>
        <div className={styles.iconContainer}>
          <Icon color={color} name={"calendar_month"} size={36} />
        </div>
        <div className={styles.textContainer}>{text}</div>
      </div>
    );
  };

  const decodeOptionShort = (option) => {
    if (!isMobile) {
      switch (option) {
        case "oneYear":
          return returnIconWrapper("#ee0e0e", "1 year subscription");
        case "threeYear":
          return returnIconWrapper("#f26925", "3 year subscription");
        case "fiveYear":
          return returnIconWrapper("#05b008", "5 year subscription");
      }
    } else {
      switch (option) {
        case "oneYear":
          return "1 Year";
        case "threeYear":
          return "#f26925", "3 Year";
        case "fiveYear":
          return "#05b008", "5 Year";
      }
    }
  };

  function decodeOptionShortCart(option) {
    switch (option) {
      case "oneYear":
        return "1 Year";
      case "threeYear":
        return "3 Years";
      case "fiveYear":
        return "5 Years";
      default:
        return "";
    }
  }

  const decodeOption = (option) => {
    switch (option) {
      case 365:
        return "oneYear";
      case 365 * 3:
        return "threeYear";
      case 365 * 5:
        return "fiveYear";
    }
  };

  const decodeOptionTextToInt = (option) => {
    switch (option) {
      case "oneYear":
        return 365;
      case "threeYear":
        return 365 * 3;
      case "fiveYear":
        return 365 * 5;
    }
  };

  const PriceDisplay = (duration) => {
    switch (duration) {
      case 365:
        return 240;
      case 365 * 3:
        return 648;
      case 365 * 5:
        return 900;
      default:
    }
  };

  const quietRefresh = async () => {
    const customerPaymentProfile = await Promise.all([
      get(`/customers/paymentprofile`),
    ]);
    customerPaymentProfile &&
      customerPaymentProfile[0] &&
      customerPaymentProfile[0]?.length > 0 &&
      setCustomerPaymentProfile(customerPaymentProfile[0]);

    setManageSubscription(!manageSubscription);
  };

  const enterRenewalMode = () => {
    if (!enableSelectionMode) {
      const inactiveLicenses = subcriptionSummary?.licenses;

      inactiveLicenses.map((lic) => {
        if (
          (!lic.active && lic.auto_renew) ||
          (lic.active &&
            moment(lic.expiry_date).diff(moment.utc(), "days") <= 31)
        ) {
          handleAddToCart(
            decodeOption(lic?.duration || lic.subscription?.duration),
            lic.device?.serial_number,
            1
          );
        }
      });

      setLicencesSelectedForRenewal(
        inactiveLicenses
          ?.filter(
            (lic) =>
              (!lic.active && lic.auto_renew) ||
              (lic.active &&
                moment(lic.expiry_date).diff(moment.utc(), "days") <= 31)
          )
          .map((lic) => lic.id)
      );
    } else {
      setCart([]);
    }
    setEnableSelectionMode(!enableSelectionMode);
  };

  const selectAllRenew = async () => {
    setSelectingAll(true);
    if (enableSelectionMode) {
      const renewableLicenses = subcriptionSummary?.licenses?.filter(
        (lic) =>
          !lic.active ||
          (lic.active &&
            moment(lic.expiry_date).diff(moment.utc(), "days") <= 31)
      ) || [];

      // Select all
      const newlySelectedIds = [];
      renewableLicenses.forEach((lic) => {
        if (!licencesSelectedForRenewal.includes(lic.id)) {
          handleAddToCart(
            decodeOption(lic?.duration || lic.subscription?.duration),
            lic.device?.serial_number,
            1
          );
          newlySelectedIds.push(lic.id);
        }
      });
      setLicencesSelectedForRenewal([
        ...licencesSelectedForRenewal,
        ...newlySelectedIds,
      ]);
    } else {
      for (const lic of subcriptionSummary?.licenses || []) {
        if (!lic.auto_renew) {
          await changeStateForLicenseId(lic?.subscription?.id, lic.id, true);
        }
      }
    }
    setSelectingAll(false);
  };

  const displayDuration = (duration) => {
    switch (duration) {
      case 365:
        return "1 Year / $240";
      case 365 * 3:
        return "3 Years / $648";
      case 365 * 5:
        return "5 Years / $900";
      default:
        return "";
    }
  };

  function displaySubscriptions() {
    return (
      <>
        <Frame>
          {isMobile ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "10px",
              }}
            >
              <DataValue label="Active subscription">
                <StatusIndicator status={"OK"} />
                {subcriptionSummary?.licenses?.filter((lic) => lic.active)
                  .length || 0}
              </DataValue>
              <div style={{ width: "80px" }} />
              <DataValue label="Expired subscription">
                <StatusIndicator status={"INACTIVE_EXPIRED_LICENSE"} />
                {subcriptionSummary?.licenses_expired_count}
              </DataValue>
              <div style={{ width: "80px" }} />
              <DataValue label="Expiring soon">
                <StatusIndicator status={"BATTERY_LOW"} />
                {subcriptionSummary?.subscriptions_expiring_this_cycle}
              </DataValue>
            </div>
          ) : (
            <InputRow>
              <DataValue label="Active subscription">
                <StatusIndicator status={"OK"} />
                {subcriptionSummary?.licenses?.filter((lic) => lic.active)
                  .length || 0}
              </DataValue>
              <DataValue label="Expired subscription">
                <StatusIndicator status={"INACTIVE_EXPIRED_LICENSE"} />
                {subcriptionSummary?.licenses_expired_count}
              </DataValue>
              <DataValue label="Expiring soon">
                <StatusIndicator status={"BATTERY_LOW"} />
                {subcriptionSummary?.subscriptions_expiring_this_cycle}
              </DataValue>
              {!isMobile && (
                <>
                  <Space />
                  <Space />
                  <Space />
                  <Space />
                </>
              )}
            </InputRow>
          )}
          <div className={styles.alightRight}>
            <Button
              onClick={() =>
                customerPaymentProfile
                  ? enterRenewalMode()
                  : setOpenAddCCModal(true)
              }
              disabled={
                paymentInProgress ||
                (subcriptionSummary?.licenses_expired_count === 0 &&
                  subcriptionSummary?.subscriptions_expiring_this_cycle === 0)
              }
              theme="primary"
              noHeight={true}
            >
              Renew subscription
            </Button>
          </div>
          {cart.length > 0 && (
            <>
              <FrameFooter>{displayCartItems(false)}</FrameFooter>
              <FrameFooter>{_checkoutButtonsForOpeningModal()}</FrameFooter>
              <Space />
            </>
          )}
          <div className={styles.rowFull}>
            <div className={styles.twoRows}></div>
            <div className={styles.license}>
              <div className={[styles.row, styles.rowHeader].join(" ")}>
                <div className={styles.rowItem}>
                  <b>Serial number</b>
                </div>
                <div className={styles.rowItem}>
                  <b>Device Status</b>
                </div>
                <div className={styles.rowItem}>
                  <b>License Status</b>
                </div>
                <div className={styles.rowItem}>
                  <b>Expiration date</b>
                </div>
                <div className={styles.rowItem}>
                  <b>Renewal length / cost</b>
                </div>

                <div className={styles.rowItem}>
                  <div style={{ display: "flex", flexDirection: "inline" }}>
                    <b>Renew</b>
                    {selectingAll ? (
                      <div style={{ marginTop: "4px" }}>
                        <CircularProgress size={12} />
                      </div>
                    ) : (
                      <>
                        &nbsp;
                        <Button
                          size={"s"}
                          onClick={() => selectAllRenew()}

                        >
                          Select All
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {subcriptionSummary?.licenses?.map((lic) => {
                return (
                  <div
                    className={[
                      styles.twoRows,
                      licencesSelectedForRenewal.indexOf(lic.id) > -1
                        ? styles.selectedToRenew
                        : "",
                    ].join(" ")}
                  >
                    <div className={styles.row}>
                      <div className={styles.rowItem}>
                        {lic.device ? (
                          <div style={{ display: "flex", alignItems: "center" }}>

                            {lic.asset_link ? (
                              <Link to={`/assets/${lic?.asset_link || "#"}`}>
                                {lic?.asset_link
                                  ? lic.device?.serial_number
                                  : "No asset"}
                              </Link>
                            ) : (
                              <div className={styles.grayText}>
                                {lic.device?.serial_number} - No asset
                              </div>
                            )}
                          </div>
                        ) : (
                          "No device"
                        )}
                      </div>
                      <div className={styles.rowItem}>
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            borderRadius: "50%",
                            backgroundColor:
                              getStatus(lic.device?.status)?.colors?.[0] ||
                              "#777777",
                            marginRight: "8px",
                            flexShrink: 0,
                          }}
                        />
                        {getStatus(lic.device?.status)?.name || "Unknown"}
                      </div>
                      <div className={styles.rowItem}>
                        {lic.active ? (
                          moment(lic.expiry_date).diff(moment.utc(), "days") <=
                            31 ? (
                            <p className={styles.expiringsoon}>
                              <b> Expiring soon</b>
                            </p>
                          ) : (
                            "Active"
                          )
                        ) : (
                          <p className={styles.expired}>
                            <b>Expired subscription</b>
                          </p>
                        )}
                      </div>

                      {lic.active ? (
                        moment(lic.expiry_date).diff(moment.utc(), "days") <=
                          31 ? (
                          <p className={styles.expiringsoon}>
                            <b>
                              {" "}
                              {moment
                                .utc(lic.expiry_date)
                                .format("MMM Do YYYY")}
                            </b>
                          </p>
                        ) : (
                          <div className={styles.rowItem}>
                            {moment.utc(lic.expiry_date).format("MMM Do YYYY")}
                          </div>
                        )
                      ) : (
                        <div className={styles.rowItem}>
                          <p className={styles.expired}>
                            <b>
                              {moment
                                .utc(lic.expiry_date)
                                .format("MMM Do YYYY")}
                            </b>
                          </p>
                        </div>
                      )}

                      <div className={styles.rowItem}>
                        <>
                          {enableSelectionMode ? (
                            <>
                              <Select
                                disabled={
                                  loading ||
                                  !licencesSelectedForRenewal.find(
                                    (id) => id === lic.id
                                  )
                                }
                                value={displayDurationSelectionForDevice(
                                  lic.device?.serial_number
                                )}
                                onChange={(e) =>
                                  changeDurationForDeviceInCart(lic, e)
                                }
                                compact={true}
                              >
                                <option disabled value={-1}>
                                  Choose length
                                </option>

                                <option key={1} value={365}>
                                  1 year / $240
                                </option>

                                <option key={2} value={365 * 3}>
                                  3 years / $648
                                </option>
                                <option key={5} value={365 * 5}>
                                  5 years / $900
                                </option>
                              </Select>
                            </>
                          ) : (
                            displayDuration(
                              lic?.duration || lic.subscription.duration
                            )
                          )}
                        </>
                      </div>
                      <div className={styles.rowItem}>
                        {enableSelectionMode ? (
                          <div className={styles.rowItemMini}>
                            <CheckboxWithLabel
                              checked={
                                licencesSelectedForRenewal.indexOf(lic.id) > -1
                              }
                              disabled={
                                lic.active == true &&
                                moment(lic.expiry_date).diff(
                                  moment.utc(),
                                  "days"
                                ) <=
                                31 ==
                                false
                              }
                              onChange={(e) => {
                                const item = cart.find(
                                  (item) =>
                                    item.option ===
                                    decodeOption(
                                      lic?.duration ||
                                      lic.subscription?.duration
                                    )
                                );

                                if (e.target.checked) {
                                  if (item) {
                                    const updatedCart = cart.map((item) =>
                                      item.option ===
                                        decodeOption(lic.subscription?.duration)
                                        ? {
                                          ...item,
                                          quantity: item.quantity + 1,
                                          serial_number: [
                                            ...item.serial_number,
                                            lic.device?.serial_number,
                                          ],
                                        }
                                        : item
                                    );
                                    setCart(updatedCart);
                                  } else {
                                    handleAddToCart(
                                      decodeOption(
                                        lic?.duration ||
                                        lic.subscription?.duration
                                      ),
                                      lic.device?.serial_number,
                                      1
                                    );
                                  }

                                  setLicencesSelectedForRenewal([
                                    ...licencesSelectedForRenewal,
                                    lic.id,
                                  ]);
                                } else {
                                  const itemWithSerialInCart = cart?.find(
                                    (item) =>
                                      item?.serial_number?.includes(
                                        lic.device?.serial_number
                                      )
                                  );
                                  if (itemWithSerialInCart) {
                                    const updatedCart = cart?.map((item) =>
                                      item?.serial_number?.includes(
                                        lic.device?.serial_number
                                      )
                                        ? {
                                          ...item,
                                          quantity: item.quantity - 1,
                                          serial_number:
                                            item.serial_number.filter(
                                              (sn) =>
                                                sn !==
                                                lic.device?.serial_number
                                            ),
                                        }
                                        : item
                                    );
                                    const filteredCart = updatedCart.filter(
                                      (item) => item.quantity > 0
                                    );
                                    setCart(filteredCart);
                                  } else {
                                    if (item && item.quantity > 1) {
                                      const updatedCart = cart.map((item) =>
                                        item.option ===
                                          decodeOption(
                                            lic?.duration ||
                                            lic.subscription?.duration
                                          )
                                          ? {
                                            ...item,
                                            quantity: item.quantity - 1,
                                            serial_number:
                                              item.serial_number.filter(
                                                (sn) =>
                                                  sn !==
                                                  lic.device?.serial_number
                                              ),
                                          }
                                          : item
                                      );
                                      setCart(updatedCart);
                                    } else {
                                      const updatedCart = cart.filter(
                                        (item) =>
                                          item.option !==
                                          decodeOption(
                                            lic?.duration ||
                                            lic.subscription?.duration
                                          )
                                      );
                                      const filteredCart = updatedCart.filter(
                                        (item) => item.quantity > 0
                                      );
                                      setCart(filteredCart);
                                    }
                                  }
                                  setLicencesSelectedForRenewal(
                                    licencesSelectedForRenewal.filter(
                                      (id) => id !== lic.id
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        ) : (
                          <CheckboxWithLabel
                            key={lic.id}
                            loading={loadingLicenseId == lic.id}
                            checked={lic.auto_renew}
                            onChange={(e) =>
                              changeStateForLicenseId(
                                lic?.subscription?.id,
                                lic.id,
                                e.target.checked
                              )
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Frame>
      </>
    );
  }

  const displayDurationSelectionForDevice = (serial_number) => {
    const itemInCart = cart?.find((item) =>
      item?.serial_number?.includes(serial_number)
    );
    if (itemInCart) {
      const decodedLength = decodeOptionTextToInt(itemInCart.option);
      return decodedLength;
    }
    const license = subcriptionSummary?.licenses?.find(
      (lic) => lic.device?.serial_number === serial_number
    );
    return license?.duration || license?.subscription?.duration;
  };

  const changeDurationForDeviceInCart = (lic, e) => {
    const newDuration = parseInt(e.target.value, 10);

    const updatedCart = cart.map((item) => {
      if (item?.serial_number?.includes(lic.device?.serial_number)) {
        return {
          ...item,
          quantity: item.quantity - 1,
          serial_number: item.serial_number.filter(
            (sn) => sn !== lic.device?.serial_number
          ),
        };
      }
      return item;
    });

    const filteredCart = updatedCart.filter((item) => item.quantity > 0);

    const existingNewDurationItem = filteredCart.find(
      (item) => item.option === decodeOption(newDuration)
    );

    if (existingNewDurationItem) {
      //check if existing old duration item has the same serial number
      const finalCart = filteredCart.map((item) => {
        if (
          item.serial_number.includes(lic.device?.serial_number !== undefined)
        ) {
          const serialIndex = item.serial_number.indexOf(
            lic.device?.serial_number
          );
          if (serialIndex > -1) {
            const updatedSerialNumbers = [...item.serial_number];

            updatedSerialNumbers.splice(serialIndex, 1);
            return {
              ...item,
              quantity: item.quantity - 1,
              serial_number: updatedSerialNumbers,
            };
          }
        }
        return item;
      });

      setCart(
        finalCart.map((item) =>
          item.option === decodeOption(newDuration)
            ? {
              ...item,
              quantity: item.quantity + 1,
              serial_number: [
                ...item.serial_number,
                lic.device?.serial_number,
              ],
            }
            : item
        )
      );
    } else {
      const existingOldDurationItem = filteredCart.find(
        (item) =>
          item.option ===
          decodeOption(lic?.duration || lic.subscription?.duration)
      );

      const finalCart = existingOldDurationItem
        ? filteredCart
          .map((item) => {
            if (
              item.option ===
              decodeOption(lic?.duration || lic.subscription?.duration)
            ) {
              // Remove the serial number from the old duration item{
              const serialIndex = item.serial_number.indexOf(
                lic.device?.serial_number
              );
              if (serialIndex > -1) {
                const updatedSerialNumbers = [...item.serial_number];
                updatedSerialNumbers.splice(serialIndex, 1);
                return {
                  ...item,
                  quantity: item.quantity - 1,
                  serial_number: updatedSerialNumbers,
                };
              }
            }
            return item;
          })
          .filter((item) => item.quantity > 0)
        : filteredCart;

      setCart([
        ...finalCart,
        {
          option: decodeOption(newDuration),
          quantity: 1,
          price: PriceDisplay(newDuration),
          serial_number: [lic.device?.serial_number],
        },
      ]);
    }
  };

  function renderContent() {
    return (
      <>
        <Space size="s">
          {subcriptionSummary.devices_with_expired_license && (
            <>
              {subcriptionSummary.available_subscriptions +
                subcriptionSummary.licenses_active_no_device.length >
                0
                ? subcriptionSummary.available_subscriptions +
                  subcriptionSummary.licenses_active_no_device.length >
                  1
                  ? "There are " +
                  (subcriptionSummary.available_subscriptions +
                    subcriptionSummary.licenses_active_no_device.length) +
                  " subscriptions available. Choose the serial numbers below."
                  : subcriptionSummary.available_subscriptions +
                    subcriptionSummary.licenses_active_no_device.length ==
                    0
                    ? "You do not have an available subscription."
                    : "There is 1 subscription available. Choose the serial number below."
                : "Zero devices available"}
            </>
          )}
        </Space>

        {displayDevicesVsSubscriptionCounter()}

        <div className={styles.center}>
          <InputRow>
            <div className={styles.wrap2}>
              {stepOption(
                "Automatically",
                "Choose this option if you want the subscription automatically assigned.",
                true
              )}
              {stepOption(
                "Manually",
                "Choose this option if you want to manually assign the subscription.",
                false
              )}
            </div>
          </InputRow>
        </div>
        <Space size="s" />
        {autoRenew ? (
          ""
        ) : devicesLoading == false && noLicense ? (
          <>
            <Space size="s">
              <Button
                size={"s"}
                onClick={() => selectAll()}
                disabled={disabledAutomatic}
              >
                Select All
              </Button>
              {"  "}
              <Button size={"s"} onClick={() => setSelectedDevicesToAssign([])}>
                Select None
              </Button>
            </Space>
            {devicesLoading ? (
              <LoadingFrame />
            ) : (
              expiredLicense?.map((dev) => {
                return (
                  <div key={dev.id} className={styles.filter}>
                    {
                      <CheckboxWithLabel
                        key={dev.id}
                        label={dev.serial_number}
                        checked={
                          selectedDevicesToAssign.indexOf(dev.id) > -1
                            ? true
                            : false
                        }
                        onChange={(e) => modifyTypes(dev.id, e.target.checked)}
                        disabled={
                          selectedDevicesToAssign.length + 1 >
                          subcriptionSummary.available_subscriptions +
                          subcriptionSummary.licenses_active_no_device
                            .length && shouldBeDisabled(dev.id)
                        }
                      />
                    }
                  </div>
                );
              })
            )}
          </>
        ) : (
          "No expired subscription"
        )}
      </>
    );
  }

  return loading ? (
    <LoadingFrame />
  ) : (
    <>
      <SalesRepresentativeBanner />
      {subcriptionSummary ? (
        <>
          <Space size="l">
            <FrameHeader title={`Subscription details`}></FrameHeader>
            {displaySubscriptions()}
            {openCheckoutModal && displayCheckoutModal()}
            <Space />
            <PaymentProfile
              onRefresh={fetchCustomerSubscriptons}
              openAddModal={openAddCCModal}
              closeAddModal={() => setOpenAddCCModal(false)}
              quietRefresh={quietRefresh}
            />
          </Space>

          {assigning && (
            <Modal footer={_renderModelFooter()}>
              <>
                <Space size="s">
                  <h2>Subscription wizard</h2>
                </Space>
                {renderContent()}
              </>
            </Modal>
          )}
        </>
      ) : (
        <>Unable to load subscription details, sorry.</>
      )}
    </>
  );
}
